
import { Component, inject, input, viewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../../shared/services/dialog.service';
import { InformationChartDialogComponent } from '../../../shared/information-chart-dialog/information-chart-dialog.component';


@Component({
  selector: 'app-info-icon-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-icon-dialog.component.html',
  styleUrl: './info-icon-dialog.component.scss'
})
export class InfoIconDialogComponent {
  dialog = viewChild.required('dialog', { read: ViewContainerRef });
  private dialogService = inject(DialogService);
  public dialogInformationId = input<string>('');

  openInformation() {
    this.dialogService.show(this.dialog(), InformationChartDialogComponent, null, this.dialogInformationId()).subscribe();
    return false;
  }
}
